import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md text-center border border-border rounded-lg bg-card p-10" data-testid="payment-cancel-page">
        <XCircle className="h-12 w-12 mx-auto text-muted-foreground" />
        <h1 className="font-heading text-2xl font-bold tracking-tight mt-5">Checkout canceled</h1>
        <p className="text-muted-foreground mt-2 text-sm">No charge was made. You can start your free trial anytime.</p>
        <Button className="mt-6" onClick={() => navigate("/pricing")} data-testid="cancel-back-button">Back to plans</Button>
      </div>
    </div>
  );
}
